var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TaxonomyList',{attrs:{"showIcons":true,"targetPath":'forms',"listClass":'level-2'}})}
var staticRenderFns = []

export { render, staticRenderFns }